var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-item',[_c('v-card',{staticClass:"d-flex flex-column align-center",attrs:{"flat":""}},[_c('v-card',{staticClass:"mb-2 radius-4 w-100 border_eee default_gray",staticStyle:{"height":"103px"},attrs:{"flat":""}}),_c('div',{staticClass:"v-chip default_gray"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }